import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function ProgramFAQ({ faqs = [], title = "Frequently asked questions", subtitle }) {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;
  return (
    <section className="" data-testid="program-faq">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="eyebrow">FAQ</p>
          <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mt-3 leading-[1.1]">
            {title}
          </h3>
          {subtitle && (
            <p className="mt-3 text-slate-600 leading-relaxed text-sm">{subtitle}</p>
          )}
        </div>
        <div className="lg:col-span-8 grid gap-3">
          {faqs.map((f, i) => (
            <button
              key={i}
              onClick={() => setOpen(open === i ? -1 : i)}
              className={`text-left rounded-2xl border bg-white p-5 transition-colors ${
                open === i ? "border-slate-300 shadow-sm" : "border-slate-200 hover:border-slate-300"
              }`}
              data-testid={`faq-item-${i}`}
            >
              <div className="flex items-start justify-between gap-4">
                <p className="font-display font-bold text-slate-900 text-base">
                  {f.question}
                </p>
                <ChevronDown
                  className={`h-5 w-5 text-slate-400 shrink-0 transition-transform ${
                    open === i ? "rotate-180 text-slate-900" : ""
                  }`}
                />
              </div>
              {open === i && (
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                  {f.answer}
                </p>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
